const form3 = {
  formId3: "new-user-form-3",
  formField3: {
    year: {
      name: "year",
      label: "[01] Kỳ tính thuế: Năm",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập năm",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    
    carrierName: {
      name: "carrierName",
      label: "[04] Tên hãng vận tải nước ngoài:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên hãng vận tải nước ngoài",
    },
    countryName: {
      name: "countryName",
      label: "[05] Nước cư trú:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn nước cư trú",
    },

    vehicleName: {
      name: "vehicleName",
      label: "[06] Tên/ hô hiệu phương tiện vận tải:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên/ hô hiệu phương tiện vận tải",
    },
    taxPayerInstead: {
      name: "taxPayerInstead",
      label: "[07] Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bên Việt Nam khấu trừ và nộp thuế thay",
    },

    taxPayerInsteadId: {
      name: "taxPayerInsteadId",
      label: "[08] Mã số thuế nộp thay của bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form3;
